import React, { useEffect, lazy, Suspense } from 'react';

import useApi, { GET_USER_DASHBOARDS } from 'hooks/useApi';
import Container from 'components/Container';
import Page from 'layout/Page';
import LoadingSpinner from 'components/LoadingSpinner';
import Typography from '@material-ui/core/Typography';
import makeStyles from '@material-ui/core/styles/makeStyles';

const DashboardsList = lazy(() => import('../DashboardsList/DashboardsList'));

const UserDashboards = () => {
  const [state, makeRequest] = useApi();
  const { data } = state;

  const useStyles = makeStyles(() => ({
    title: {
      textAlign: 'left',
      font: '20px',
      letterSpacing: '0px',
      padding: '18px',
      outline: 'none'
    }
  }));

  const classes = useStyles();

  useEffect(() => {
    makeRequest(GET_USER_DASHBOARDS());
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <Page title="My Dashboards">
      <Container center maxWidth="xl">
        <Suspense fallback={<LoadingSpinner />}>
          {data && data.length === 0 && (
            <Typography variant="h5" className={classes.title}>
              No dashboards created yet.
            </Typography>
          )}
          {data && data.length !== 0 && (
            <DashboardsList linkUrlPrefix="dashboard" items={data && data.length && data} />
          )}
        </Suspense>
      </Container>
    </Page>
  );
};

export default UserDashboards;
